// extracted by mini-css-extract-plugin
export default {"indicators":"CarouselIndicators_indicators__RLmDi","indicator":"CarouselIndicators_indicator__zhgKk","activeIndicator":"CarouselIndicators_activeIndicator__8C-QY"};